import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './IntentArchive.css';

const IntentArchive = () => {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in-view'); }),
      { threshold: 0.12 }
    );
    document.querySelectorAll('.ia-reveal').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="ia-root">
      <Helmet>
        <title>The Intent Archive · dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/intent-archive" />
        <meta name="description" content="100 years from now you won't be here, but the dreams you chased should still exist. dmyor is the world's intent archive: store your vision, plan it, and preserve the attempt forever." />
        <meta property="og:title" content="The Intent Archive · dmyor" />
        <meta property="og:description" content="100 years from now you won't be here, but the dreams you chased should still exist. dmyor preserves the attempt, forever." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dmyor.com/intent-archive" />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="ia-page">

        <span className="ia-eyebrow ia-reveal">The world's intent archive</span>

        <h1 className="ia-hero ia-reveal">
          100 years from now,<br />
          you won't be here.<br />
          <span className="ia-clay">The dreams you chased should still exist.</span>
        </h1>

        <section className="ia-sec ia-reveal">
          <h2 className="ia-h">Most dreams aren't lost to failure. They're forgotten.</h2>
          <p className="ia-p">
            Everyone has a thought they mean to act on someday. Someday rarely comes, and
            in time we forget we ever wanted it.
          </p>
        </section>

        <section className="ia-sec ia-reveal">
          <h2 className="ia-h">Write it down before it fades.</h2>
          <p className="ia-p">
            Capture the vision, however raw, and give it a timeframe of one to five years.
            The moment it's written, it's real, and it stops slipping away.
          </p>
        </section>

        <section className="ia-sec ia-reveal">
          <h2 className="ia-h">Dmyor Assist turns it into a plan you can actually walk.</h2>
          <p className="ia-p">
            Dmyor Assist breaks your intent into milestones, actions, and daily habits in seconds.
            No blank page. Just the next small step, one at a time.
          </p>
        </section>

        <section className="ia-sec ia-reveal">
          <h2 className="ia-h">The story of how you made it real, preserved.</h2>
          <p className="ia-p">
            At its root, dmyor is an archive of human dreams: a record of what people set out
            to become, and how they got there. The world is moving faster than ever. Your
            journey should outlast it.
          </p>
        </section>

        <div className="ia-end ia-reveal">
          <p className="ia-p ia-p--close">
            Ready to leave your journey to your dreams, for eternity? Write the first line
            today. Whatever becomes of it, the record that you tried will remain long after
            you're gone.
          </p>
          <Link to="/dashboard/planning/new" className="ia-btn">Start your vision</Link>
          <p className="ia-sig">dmyor. Make it real.</p>
        </div>

      </div>
    </div>
  );
};

export default IntentArchive;
